module.exports = __webpack_public_path__ + "img/ic-close.c30d48a3.svg";